import { render, staticRenderFns } from "./tian-map.vue?vue&type=template&id=a4638418&scoped=true&"
import script from "./tian-map.vue?vue&type=script&lang=js&"
export * from "./tian-map.vue?vue&type=script&lang=js&"
import style0 from "./tian-map.vue?vue&type=style&index=0&id=a4638418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4638418",
  null
  
)

export default component.exports